import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useModal } from "../../contexts/ModalContext";
import BookingPopup from '../../components/BookingPopup';
// const settingskey = {
//   autoplay: true,
//   cssEase: "ease",
//   speed: 3000,
//   autoplaySpeed: 2400,
//   infinite: true,
//   arrows: false,
//   dots: false,
//   pauseOnHover: true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: { slidesToShow: 2 },
//     },


//     {
//       breakpoint: 767,
//       settings: { slidesToShow: 1 },
//     },
//     {
//       breakpoint: 99999,
//       settings: "unslick",
//     },
//   ],
// };
export default function HomeWork({ data }) {
  const [showSerachEngine, setshowSerachEngine] = useState(false);
  const { openQueryModal } = useModal();
  return (
    <>
      <section className="home-new-work">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-9">
              <div className="services-text">
                <h2 className="heading">how it  works</h2>
                <div className="works-content">
                  <p>Renting a dumpster is quick and hassle-free just follow these  simple steps to get started today.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="home-booking">
            <div className="row booking-rows">
              <div className="col-5 col-sm-5 col-md-5">
                <div className="booking-wrap">
                  <div className="number-text">
                    <div className="icons">
                      <img src="/assets/images/new-booking-img1.webp" className="img-responsive" alt="Icon" loading="lazy" />
                    </div>
                  </div>
                  <div className="heading-wrap">
                    <div className="heading-sec">
                      <div className="heading">Call Us For Booking</div>
                      <div className="booking-btn">
                        <Link className="theme-btn" to="tel:+1 780 230 1359"> <span className="color-overlay"></span> 
                        <span className="btn-txt">Call Us Now</span></Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-2 col-sm-2  col-lg-2 ">
                <div className="booking-wraps">
                  <div className="heading">OR</div>
                </div>
              </div>
              <div className="col-5 col-sm-5 col-md-5">
                <div className="booking-wrap">
                  <div className="number-text">
                    <div className="icons">
                      <img src="/assets/images/new-booking-img2.webp" className="img-responsive" alt="Icon" loading="lazy" />
                    </div>
                  </div>
                  <div className="heading-wrap">
                    <div className="heading-sec">
                      <div className="heading">Book Online</div>
                      <div className="booking-btn">
                        <Link className="theme-btn" onClick={() => setshowSerachEngine(true)} >
                         <span className="color-overlay"></span> <span className="btn-txt"> Book Online</span></Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="works-slides">
            <div  className="new-work-sliders">
              {data?.map((item, index) => (
                <div className="sliders-col" key={index}>
                  <div className="sliders-col-inner">
                    <div className="icon">   <img src={item.icon} alt="icon" className="img-responsive" loading="lazy" /></div>
                    <div className="heading" dangerouslySetInnerHTML={{ __html: item.title }}></div>
                    <p>{item.desc}</p>
                    <div className="step-wrap">{item.step}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <BookingPopup isOpen={showSerachEngine} onClose={() => setshowSerachEngine(false)} />
    </>
  );
}
